module.exports = __webpack_public_path__ + "static/media/DetailsEpsonCRProjector3.2cdc6cdb.png";